import { useQuery } from "@tanstack/react-query";
import { Map, Search, SlidersHorizontal } from "lucide-react";
import { useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PropertyCard from "../components/PropertyCard";
import PropertyFilters from "../components/PropertyFilters";
import { useScrollLock } from "../hooks/useScrollLock";
import SiteFooter from "../components/SiteFooter";
import { getProperties } from "../lib/api";

export default function PropertiesPage({ favorites, onFavorite }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [mapOpen, setMapOpen] = useState(false);
  const filterScrollPositionRef = useRef(null);
  const filters = Object.fromEntries([...searchParams.entries()].filter(([, value]) => value));
  const { data: properties = [], isLoading } = useQuery({ queryKey: ["properties", filters], queryFn: () => getProperties(filters) });

  useScrollLock(filtersOpen, "filters-open", filterScrollPositionRef.current);
  const captureFilterScrollPosition = () => {
    filterScrollPositionRef.current = window.scrollY;
  };

  return (
    <main data-testid="properties-page">
      <section className="listing-hero container">
        <p className="eyebrow">Nos adresses</p>
        <h1>Votre prochain<br /><span>coup de cœur.</span></h1>
        <p data-testid="properties-count">{isLoading ? "Recherche en cours" : `${properties.length} bien${properties.length > 1 ? "s" : ""} à découvrir dans le Vaucluse`}</p>
      </section>
      <section className="listing-content container">
        {filtersOpen && <button className="filter-backdrop" onClick={() => setFiltersOpen(false)} data-testid="mobile-filter-backdrop" aria-label="Fermer les filtres" />}
        <PropertyFilters isOpen={filtersOpen} searchParams={searchParams} setSearchParams={setSearchParams} onClose={() => setFiltersOpen(false)} />
        <div className="listing-results">
          <div className="listing-toolbar"><button className="mobile-filter-button" onPointerDown={captureFilterScrollPosition} onClick={() => setFiltersOpen(true)} data-testid="mobile-filter-button"><SlidersHorizontal size={17} /> Filtres</button><button className="map-button" onClick={() => setMapOpen((open) => !open)} data-testid="open-map-button"><Map size={17} /> {mapOpen ? "Liste" : "Carte"}</button></div>
          {mapOpen && <div className="listing-map" data-testid="properties-map"><iframe title="Carte des biens dans le Vaucluse" src="https://www.google.com/maps?q=Vaucluse&output=embed" loading="lazy" referrerPolicy="no-referrer-when-downgrade" /></div>}
          <div className="property-grid" data-testid="properties-grid">
            {isLoading ? <p data-testid="listing-loading">Chargement des adresses...</p> : properties.map((property) => <PropertyCard key={property.id} property={property} onFavorite={onFavorite} isFavorite={favorites.some((item) => item.id === property.id)} />)}
          </div>
          {!isLoading && properties.length === 0 && <div className="empty-state" data-testid="no-properties-message"><Search size={25} /><p>Aucun bien ne correspond à ces critères.</p><button onClick={() => setSearchParams({})} data-testid="empty-reset-filters-button">Voir tous les biens</button></div>}
        </div>
      </section>
      <SiteFooter />
    </main>
  );
}